import { z } from 'zod';
import { dateValidation } from '../../../validation';

export const CareDocumentRefSchema = z.object({
  id: z.string().min(1),
  ref: z.string().min(1),
  createdAt: dateValidation().optional(),
});
